import { useQuery } from '@gogame/query';

import { loadFinancialResults } from 'scenes/FinancialResults/sources/financialResults';

import { grid } from './queryKeyFactory';

export const useLoadFinancialResults = (params) => {
  return useQuery(
    grid(params),
    (_, { signal }) => loadFinancialResults(params, { signal }),
    {
      enabled: true,
    }
  );
};
